export default __webpack_public_path__ + "static/media/date_circle.5f8076a3.svg";